import { useStores } from '@/hooks/use-stores';

import { Entity } from '../../../NodeWidget.types';
import { areArraysEqual, DEFAULT_MODEL_IDS } from '../../EditAssetDrawer.utils';

export const useInitialValues = (entity: Entity) => {
  const { pidEditStore } = useStores();
  const connectFrom = pidEditStore.getDraftDeviceWithoutPipesByIdFromDevices(entity.deviceId);
  const initialDeviceModelId = entity.deviceModelId ?? DEFAULT_MODEL_IDS.productionFloor;

  return {
    name: entity.name,
    deviceModelId: initialDeviceModelId,
    connectFrom,
  };
};

export const mapFormValuesToPayload = (values, entity, initialValues) => ({
  name: values.name,
  deviceModelId: values.deviceModelId,
  ...(!entity?.deviceId && { deviceType: entity.deviceType }),
  ...(!entity?.deviceId &&
    !areArraysEqual(initialValues.connectFrom, values.connectFrom) && {
      from: values.connectFrom,
    }),
});
